export const knowServiceIndustriales = [
    {
        "header": "CONOCE NUESTROS",
        "title": "SERVICIOS PROFESIONALES",
        "subtitle": "A NIVEL INDUSTRIAL",
        "description": "Contamos con la experiencia y el personal capacitado para construir o darle mantenimiento a su proyecto industrial. Nos adaptamos a sus necesidades de forma práctica y segura.",
        "button": "PROYECTOS",
        "buttonLink": "/proyectos",
        "specializedHeader": "CONTAMOS",
        "specializedTitle": "CON EQUIPO",
        "specializedSubtitle": "ESPECIALIZADO Y CERTIFICADO",
        "image": "/assets/imgs/services/industriales/trabajador.jpg",
        "backgroundColor": "#1226AA"
    }
];

export const knowServiceIndustrialesEn = [
    {
        header: "DISCOVER OUR",
        title: "PROFESSIONAL SERVICES",
        subtitle: "AT AN INDUSTRIAL LEVEL",
        description:
            "We have the experience and skilled personnel to build or maintain your industrial project. We adapt to your needs in a practical and safe manner.",
        button: "PROJECTS",
        buttonLink: "/projects",
        specializedHeader: "WE HAVE",
        specializedTitle: "A SPECIALIZED",
        specializedSubtitle: "AND CERTIFIED TEAM",
        image: "/assets/imgs/services/industriales/trabajador.jpg",
        backgroundColor: "#1226AA"
    }
];

